import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from 'src/app/app.reducer';
import { ItineraryHistoryActions } from '../actions';
import * as fromReducer from '../reducers/pnr.reducer';

@Injectable()
export class ItineraryHistoryService {
  constructor(private store: Store<State>) {}

  getItineraryHistory(): Observable<string> {
    return this.store.pipe(select(fromReducer.getItineraryHistory));
  }

  dispatchLoadItineraryHistorySuccess(itineraryLogHistory: string) {
    this.store.dispatch(
      ItineraryHistoryActions.LoadItineraryHistorySuccess({ itineraryLogHistory })
    );
  }
}
